 // !! DO NOT EDIT THIS FILE DIRECTLY !!
 // !! It will be overrideen by gulp !!
 //    Please use global/scripts.js

'use strict';

/**
 * Has been modified. Do not replace. - Michael Large
 *
 * Creates and uses srcSet attributes for background images.
 * @author Jesse Kernaghan <https://github.com/jessekernaghan/bgsrcset.js>
 */
(function () {
  'use strict';

  var bgsrcset = function bgsrcset() {

    this.called = false;
    this.callonce = true;
    this.compat();
  };

  bgsrcset.prototype.init = function (target, callback) {
    //retina bool
    this.retina = window.devicePixelRatio > 1;

    //storage for our elements
    this.elements = [];

    //global onload callback for imagery
    this.callback = typeof callback === 'function' ? callback : function () {};

    //window width, for responsive handling
    this.curwidth = this.getWidth();

    //get our input and turn it into an element list of some sort
    //   var elems = this.gather(target);
    var elems = document.querySelectorAll('[data-bg-srcset]');

    //parse the element input
    for (var i = 0, l = elems.length; i < l; i++) {
      this.parse(elems[i]);
    }

    this.set();
    this.resize();
  };

  /* -----------* /
     Fix compatibility issues*
     *only down to IE8
  / *----------- */

  bgsrcset.prototype.compat = function () {
    var d = document;
    /* check for getElementsByClassName */
    if (typeof d.getElementsByClassName !== 'function') {
      d.getElementsByClassName = function (str) {
        return d.querySelectorAll('.' + str);
      };
    }

    /* check for .trim() */
    if (!String.prototype.trim) {
      String.prototype.trim = function () {
        return this.replace(/^\s+|\s+$/g, '');
      };
    }

    /*------------------------* /
      Check for Event Listener
    / *------*/
    if (!d.addEventListener) {
      this.addEvent = function (elem, evName, fn) {
        elem.attachEvent('on' + evName, function (e) {
          fn(e || window.event);
        });
      };
    }
  };

  /* -----------* /
     Gather elements
  / *----------- */

  bgsrcset.prototype.gather = function (target) {
    var autotypes = ['HTMLCollection', 'NodeList'];
    var e = target;
    var type = e.nodeType ? 'Object' : Object.prototype.toString.call(e).replace(/^\[object |\]$/g, '');

    var func = 'parse' + type;

    if (autotypes.indexOf(type) > -1) {
      return e;
    }

    if (this[func]) {
      return this[func](e);
    }

    return [];
  };

  bgsrcset.prototype.parseObject = function (target) {
    return target.nodeType ? [target] : [];
  };

  bgsrcset.prototype.parseArray = function (target) {
    return target;
  };

  bgsrcset.prototype.parseString = function (target) {

    var d = document;
    var e = target.trim();
    var sel = e[0];
    var elems = [];

    switch (true) {
      /* class */
      case sel === '.':
        elems = d.getElementsByClassName(e.substring(1));
        break;
      /* id */
      case sel === '#':
        elems.push(d.getElementById(e.substring(1)));
        break;
      /* tag */
      case /^[a-zA-Z]+$/.test(e):
        elems = d.getElementsByTagName(e);
        break;
      /* unknown */
      default:
        elems = [];
    }

    return elems;
  };

  /* -----------* /
     Parse datasrc
  / *----------- */
  bgsrcset.prototype.parse = function (obj) {
    //our data to parase
    var bgss = obj.dataset.bgSrcset;
    /* exit if no attribute */
    if (attr === null) {
      console.log("NO BG SRCSET");return false;
    }

    /* create new element object */
    this.elements.push({});

    /* split up sets */
    var set = bgss.split(',');
    var attr = '';
    var curelem = this.elements[this.elements.length - 1];

    curelem.node = obj;
    curelem.srcset = [];

    /* loop through sets to define breakpoints */
    for (var i = 0, l = set.length; i < l; i++) {
      curelem.srcset.push({});
      attr = set[i].trim();
      var attrs = attr.split(' ');
      var a;
      var e;
      var t;
      /* since we can't know the order of the values, starting another loop */
      for (var attrc = 0, attrl = attrs.length; attrc < attrl; attrc++) {
        a = attrs[attrc];
        e = curelem.srcset[i]; //current attribute
        t = a.length - 1;
        switch (true) {
          case a.trim() === "":
            //in case of extra white spaces
            continue;
          case a[t] !== 'w' && a[a.length - 1] !== 'x':
            e.src = a;
            break;
          case a[t] === 'w':
            e.width = parseInt(a.slice(0, -1));
            break;
          case a[t] === 'x':
            e.retina = parseInt(a.slice(0, -1)) > 1;
            break;
        }
        if (!e.width) {
          e.width = Number.POSITIVE_INFINITY;
        } //set to the top
        if (!e.retina) {
          e.retina = false;
        }
      }
    }
  };

  /* -----------* /
     Set image
  / *----------- */
  bgsrcset.prototype.set = function () {
    for (var i = 0, l = this.elements.length; i < l; i++) {
      this.setSingle(i);
    }
  };

  bgsrcset.prototype.setSingle = function (id) {
    var width = 0,
        elem = this.elements[id],
        comparray = [],
        best = 0,
        _this = this;

    //      width = this.getWidth(); //elem.node.offsetWidth;
    // 2017-10-06, use the container width and not window width. Experiemental.
    width = elem.node.offsetWidth;

    elem.srcset = elem.srcset.sort(dynamicSort("width"));

    for (var i = 0, l = elem.srcset.length; i < l; i++) {
      if (elem.srcset[i].width < width) {
        continue;
      }
      comparray.push(elem.srcset[i]);
    }
    if (comparray.length === 0) {
      comparray.push(elem.srcset[elem.srcset.length - 1]);
    }

    best = comparray[0];

    if (comparray.length > 1 && comparray[0].width === comparray[1].width) {
      best = comparray[0].retina !== this.retina ? comparray[1] : comparray[0];
    }

    if (best.src !== undefined && best.src !== 'null') {
      var img = new Image();
      var done = false;

      img.onload = img.onreadystatechange = function () {
        if (!done && (!this.readyState || this.readyState === "loaded" || this.readyState === "complete")) {
          done = true;

          elem.node.style.backgroundImage = "url('" + best.src + "')";

          /* only fire the callback on initial load, not resize events */
          if (!_this.called) {

            _this.callback(elem);
            _this.called = _this.callonce;
          }
        }
      };

      img.src = best.src;
    } else {
      elem.node.style.backgroundImage = "";
    }
  };

  /* -----------* /
     Handle Resize
  / *----------- */
  bgsrcset.prototype.resize = function () {
    var _this = this,
        resizeTimer = setTimeout(function () {}, 0);

    this.addEvent(window, 'resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        var w = _this.getWidth();
        if (w !== _this.curwidth) {
          _this.curwidth = w;
          _this.set();
        }
      }, 250);
    });
  };

  bgsrcset.prototype.addEvent = function (elem, evName, fn) {
    elem.addEventListener(evName, fn, false);
  };

  bgsrcset.prototype.getWidth = function () {
    var w, d, e, g;
    w = window;
    d = document;
    e = d.documentElement;
    g = d.getElementsByTagName('body')[0];

    return w.innerWidth || e.clientWidth || g.clientWidth;
  };

  function dynamicSort(property) {
    var sortOrder = 1;
    if (property[0] === "-") {
      sortOrder = -1;
      property = property.substr(1);
    }
    return function (a, b) {
      var result = a[property] < b[property] ? -1 : a[property] > b[property] ? 1 : 0;
      return result * sortOrder;a;
    };
  }

  window.bgsrcset = bgsrcset;
})();

// Creates SourceSet for background images.
var bgss = new bgsrcset();
bgss.init('.bgimg'); // Re-called in debug.js
 // !! DO NOT EDIT THIS FILE DIRECTLY !!
 // !! It will be overrideen by gulp !!
 //    Please use global/scripts.js

"use strict";

/**
* @file cookie.js
* Generic cookie handling functions.
* @author Hal Burgiss 2009-03-22
*/
function setCookie(name, value, days) {
     if (days) {
          var date = new Date();
          date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
          var expires = "; expires=" + date.toGMTString();
     } else var expires = "";
     document.cookie = name + "=" + value + expires + "; path=/";
}
function readCookie(name) {
     var nameEQ = name + "=";
     var ca = document.cookie.split(';');
     for (var i = 0; i < ca.length; i++) {
          var c = ca[i];
          while (c.charAt(0) == ' ') {
               c = c.substring(1, c.length);
          }if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
     }
     return null;
}
function eraseCookie(name) {
     setCookie(name, "", -1);
}
 // !! DO NOT EDIT THIS FILE DIRECTLY !!
 // !! It will be overrideen by gulp !!
 //    Please use global/scripts.js

'use strict';

/**
 * DBS Chevron hover
 */
jQuery(window).on('load', function () {
	jQuery('#dbs-chev').on('focus', function () {
		jQuery(this).addClass('show-additional-content');
	});
	jQuery('#dbs-chev').on('focusout', function () {
		jQuery(this).removeClass('show-additional-content');
	});
	jQuery('#dbs-chev').on('keydown', function (e) {
		if (e.keyCode == 27) {
			// escape key maps to keycode `27`
			jQuery(this).removeClass('show-additional-content');
		}
	});
});
 // !! DO NOT EDIT THIS FILE DIRECTLY !!
 // !! It will be overrideen by gulp !!
 //    Please use global/scripts.js

'use strict';

/**
 * Debounce function for rate limiting a function.
 *
 * It prevents a function from being fired too frequently. This is useful
 * for resource intensive processes like resize event handlers and tap/click
 * handlers.
 *
 *
 * @see: https://davidwalsh.name/javascript-debounce-function
 *
 * @param function func - the callback function
 * @param int wait - the time to wait in milliseconds
 * @param bool immediate - call the function immediately
 *
 * @return function - the modified function that will only run once within a wait period.
 */
function debounce(func, wait, immediate) {
  var timeout;
  if (!wait) {
    console.warn("Debounce was called without a 'wait' argument. This renders debounce almost completely ineffective.");
  }
  return function () {
    var context = this,
        args = arguments;
    var later = function later() {
      timeout = null;
      if (!immediate) {
        func.apply(context, args);
      }
    };

    var callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) {
      func.apply(context, args);
    }
  };
};

/**
 * Debounce scroll event for rate limiting scroll events.
 *
 * Putting events on the scroll handler should usually be discouraged
 * as they can be fired very frequently and this can cause the browser
 * to lag.
 *
 * Instead, use this event: debounceScroll
 *
 * This allows us to have only one scoll event handler that triggers
 * the debounceScoll event (on the window) 50ms (or whatever the
 * delay_time is set) after a scroll event starts and then stops.
 *
 *
 * @see: http://ejohn.org/blog/learning-from-twitter/#postcomment
 * (particularly read the comments for this variant)
 *
 * @usage:
 *
 *  	window.addEventListener( 'debounceScroll', function() {
 *  		console.log( 'scrolled....');
 *  	}, false );
 */
var debounceScroll = create_event('debounceScroll');

jQuery(window).on('load', function () {
  var delay_time = 50;
  var delay_start = 0;
  var last_scroll_pos = 0;
  // The one scroll event handler to rule them all.
  jQuery(window).scroll(function (event) {
    // If we are already scrolling, reset the delay
    if (delay_start) {
      clearTimeout(delay_start);
    }

    // Are we scrolling down?
    var scrollDown = $(window).scrollTop() > last_scroll_pos;
    last_scroll_pos = $(window).scrollTop(); // Save for next time

    delay_start = setTimeout(function (event) {
      debounceScroll.scrollDown = scrollDown;
      window.dispatchEvent(debounceScroll);
    }, delay_time);
  });
});
 // !! DO NOT EDIT THIS FILE DIRECTLY !!
 // !! It will be overrideen by gulp !!
 //    Please use global/scripts.js

'use strict';

/*
* Plugin Name: Resize Image to Parent Container
*
* Author: Christian Varga
* Author URI: http://christianvarga.com
* Plugin Source: https://github.com/levymetal/jquery-resize-image-to-parent/
*
*/

(function ($) {
	$.fn.resizeToParent = function (opts) {
		var defaults = {
			parent: 'div',
			contain: false,
			marginCenter: false,
			delay: 100
		};
		// console.log(opts.contain);

		var opts = $.extend(defaults, opts);

		function positionImage(obj) {
			// reset image (in case we're calling this a second time, for example on resize)
			//obj.css({'width': '', 'height': '', 'margin-left': '', 'margin-top': ''});
			if (opts.marginCenter) {
				obj.css({ 'width': '', 'height': '', 'margin-left': '', 'margin-top': 0 });
			} else {
				obj.css({ 'width': '', 'height': '', 'max-width': 'none' });
			}

			// dimensions of the parent
			var parentWidth = obj.parents(opts.parent).outerWidth() + 5; // To handle antialiasing
			var parentHeight = obj.parents(opts.parent).outerHeight() + 5; // To handle antialiasing

			// dimensions of the image
			var imageWidth = obj.width();
			var imageHeight = obj.height();

			// step 1 - calculate the percentage difference between image width and container width
			var diff = imageWidth / parentWidth;

			// step 2 - if height divided by difference is smaller than container height, resize by height. otherwise resize by width
			// console.log(opts.contain +' | '+ (imageHeight / diff) +' | '+ parentHeight);
			if (imageHeight / diff < parentHeight) {
				obj.css({ 'width': 'auto', 'height': parentHeight });

				// set image variables to new dimensions
				imageWidth = imageWidth / (imageHeight / parentHeight);
				imageHeight = parentHeight;
				// console.log('1');
				if (opts.contain) {
					obj.css({ 'height': 'auto', 'width': parentWidth });
				}
			} else {
				obj.css({ 'height': 'auto', 'width': parentWidth });

				// set image variables to new dimensions
				imageWidth = parentWidth;
				imageHeight = imageHeight / diff;
				// console.log('2');
				if (opts.contain) {
					obj.css({ 'width': 'auto', 'height': parentHeight });
				}
			}

			// step 3 - center image in container
			var leftOffset = (imageWidth - parentWidth) / -2;
			var topOffset = (imageHeight - parentHeight) / -2;

			//obj.css({'margin-left': leftOffset, 'margin-top': topOffset});
			if (opts.marginCenter) {
				obj.css({ 'margin-left': leftOffset, 'margin-top': 0 });
			}
		}

		// run the position function on window resize (to make it responsive)
		var tid;
		var elems = this;

		$(window).on('resize', function () {
			clearTimeout(tid);
			tid = setTimeout(function () {
				elems.each(function () {
					positionImage($(this));
				});
			}, opts.delay);
		});

		return this.each(function () {
			var obj = $(this);

			// hack to force ie to run the load function... ridiculous bug
			// http://stackoverflow.com/questions/7137737/ie9-problems-with-jquery-load-event-not-firing
			obj.attr("src", obj.attr("src"));

			// bind to load of image
			//			obj.load(function() {  // update for jq 3.3 HB 2019-01-09
			obj.on('load', function () {
				positionImage(obj);
			});

			// run the position function if the image is cached
			if (this.complete) {
				positionImage(obj);
			}
		});
	};
})(jQuery);
 // !! DO NOT EDIT THIS FILE DIRECTLY !!
 // !! It will be overrideen by gulp !!
 //    Please use global/scripts.js

'use strict';

/**
 * Slate Mobile Navigation Menu
 *
 */
(function ($) {

	'use strict';

	/**
  * 'is_mobile' variable to determine if this is a mobile size.
  */

	var set_is_mobile,
	    is_mobile = false;

	(set_is_mobile = function set_is_mobile() {
		is_mobile = !!jQuery('#menu-toggle')[0].offsetParent;
	})();

	jQuery(window).on('resize', debounce(set_is_mobile, 200));

	/**
  * Toggle menu open/closed when clicking menu toggle
  */
	$('#menu-toggle').click(function () {
		$(this).toggleClass('open');
		$('#menu').toggleClass('open');
		$('body').toggleClass('opened-menu');

		if ($(this).hasClass('open')) {
			$(this).attr('aria-expanded', true);
		} else {
			$(this).attr('aria-expanded', false);
		}
	});

	function close_menu() {
		$('#menu-toggle').removeClass('open');
		$('#menu').removeClass('open');
		$('body').removeClass('opened-menu');
		$('#menu-toggle').attr('aria-expanded', false);
		$('#menu-toggle').focus();
	}

	//Hide the search bar after click out of it
	jQuery('#content').on('click', function (e) {
		if ($('#menu-toggle').hasClass('open')) {
			close_menu();
		}
	});

	jQuery(window).on('keyup', function (e) {
		if (e.keyCode == 27) {
			// escape key maps to keycode `27`
			close_menu();
		}
	});

	/**
  * Toggle Submenus open/closed when clicking appropriate submenu toggle
  */
	$('.submenu-toggle').each(function () {
		var focus_out_timer = null;
		var toggle_button = jQuery(this);
		var submenu = toggle_button.parent();

		toggle_button.click(function () {
			submenu.toggleClass('open');
			toggle_button.toggleClass('open');
			if ($(this).hasClass('open')) {
				toggle_button.attr('aria-expanded', true);
			} else {
				toggle_button.attr('aria-expanded', false);
			}
		});

		/**
   * If we have focused on another anchor tag in this submenu clear the
   * timer to remove the open classes.
   */
		submenu.find('a, button').on('focus', function () {
			if (is_mobile) {
				return;
			}
			if (focus_out_timer) {
				clearTimeout(focus_out_timer);
				focus_out_timer = null;
			}
		});

		/**
   * When leaving a menu anchor tag, set a timer to clear the open
   * classes.
   */
		submenu.find('a, button').on('blur', function () {
			if (is_mobile) {
				return;
			}
			focus_out_timer = setTimeout(function () {
				submenu.removeClass('open');
				toggle_button.removeClass('open');
				toggle_button.attr('aria-expanded', false);
			}, 100);
		});
	});
})(jQuery);
 // !! DO NOT EDIT THIS FILE DIRECTLY !!
 // !! It will be overrideen by gulp !!
 //    Please use global/scripts.js

"use strict";

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/**
 * This is the script to handle the sticky header and sticky social media icons.
 */
jQuery(window).on('load', function () {

	var $window = $(window);
	var width = null;

	/**
  * Functions for determining mobile window width
  */

	// Get the width of the viewport
	function window_width() {
		// If it's already calculated, just return it
		if (width) {
			return width;
		}

		// Temporarily remove the scrollbar for an accurate width reading
		document.body.style.overflow = "hidden";
		width = $(window).width();
		document.body.style.overflow = "";
		return width;
	}
	window_width(); // Calculate it once on first load

	jQuery(window).on('resize', debounce(function () {
		width = null; // Reset width
		window_width(); // Recalculate width
	}, 100));

	// Function to determine if is_mobile
	function is_mobile() {
		return window_width() < 960 || jQuery(body).hasClass('view-as-mobile') || jQuery(body).hasClass('view-as-tablet');
	}

	/**
  * Sticky header
  */
	var $body = jQuery('body');
	var $menu_toggle = jQuery('.menu-toggle').first();

	var sticky_pos = 15; // At what position does the header become sticky?

	// Initial load:
	if ($window.scrollTop() >= sticky_pos) {
		$body.addClass('sticky-header');
	}

	// Scroll event handler
	window.addEventListener('debounceScroll', function (event) {
		if (!$body.hasClass('sticky-header') && $window.scrollTop() >= sticky_pos) {
			$body.addClass('sticky-header');
		} else if ($body.hasClass('sticky-header') && $window.scrollTop() < sticky_pos) {
			$body.removeClass('sticky-header');
		}
	}, false);

	/**
  * Hide fixed header when scrolling down in mobile, but show when scrolling up
  *
  * Putting this on a scroll event to be smoother.
  */
	var last_scroll_pos = 0;
	var delay_hide = null; // Timeout for hiding the sticky header in mobile
	var scrollDown = 0;

	window.addEventListener('scroll', function (event) {
		// Are we scrolling down?
		scrollDown = $window.scrollTop() > last_scroll_pos && $window.scrollTop() > 160;
		last_scroll_pos = $window.scrollTop(); // Save for next time

		// If we are scrolling up, don't hide the header
		if (!scrollDown) {
			$body.removeClass('sticky-header--hide'); // Remove hide class
			clearTimeout(delay_hide);
			delay_hide = null; // Reset hide timer
			return; // Nothing more to do
		}

		// If timer is already set, do nothing.
		if (delay_hide) {
			return;
		}

		// If already hidden, do nothing.
		if ($body.hasClass('sticky-header--hide')) {
			return;
		}

		// Start the timer:
		delay_hide = setTimeout(function (event) {
			$body.addClass('sticky-header--hide');
			delay_hide = null;
		}, 500);
	}, false);

	/**
  * Sticky header/footer
  *
  * NOTE: Currently the footer is no longer sticky.
  */

	/**
  * Detect if an elements position is fixed or not
  *
  * @see https://stackoverflow.com/questions/19474320/detect-whether-an-element-has-positionfixed-possibly-by-parent-element-via-jq
  */
	$.fn.isfixed = function () {
		var el = this[0];
		while ((typeof el === "undefined" ? "undefined" : _typeof(el)) === 'object' && el.nodeName.toLowerCase() !== 'body') {
			if (window.getComputedStyle(el).getPropertyValue('position').toLowerCase() === 'fixed') return true;
			el = el.parentElement;
		}
		return false;
	};

	// ---- Set body's margin-top to height of header on load ----
	function checkWindowWidth() {
		// Tablet view
		if ($('#site-header').isfixed() && window.innerWidth > 767 && window.innerWidth < 960) {
			$('body').css('margin-top', $('#site-header').height() - 7 + 'px');

			// Mobile view	
		} else if ($('#site-header').isfixed() && window.innerWidth < 768) {
			$('body').css('margin-top', $('#site-header').height() - 3 + 'px');

			// Desktop
		} else if ($('#site-header').isfixed() && window.innerWidth > 767) {
			// Using site-header__navigation element for proper height
			$('body').css('margin-top', $('#site-header__navigation').outerHeight() + 'px');

			// Not sticky
		} else {
			$('body').css('margin-top', '0px');
		}
	}

	// Run Function
	checkWindowWidth();

	// Do the above tests on every resize
	$(window).on("resize", debounce(function () {
		checkWindowWidth();
	}, 100));
});
 // !! DO NOT EDIT THIS FILE DIRECTLY !!
 // !! It will be overrideen by gulp !!
 //    Please use global/scripts.js

'use strict';

/**
* This file is loaded asyncronously in the footer.
* All custom global scripts should be included here.
*/

/*
A little info for this js file:
	As much as possible, this file should be kept organized. Currently, two major divisions are seen below, delinitated by their respective functions of "on load" and "ready".
	As mentioned below, most code added to this file should be included within the "on load" function.
	For ease of future use, include any new code at the bottom of the relevant section of the page, adding clear comments to explain the purpose of the code being written,
	including any relavant details regarding what the code overrides, etc.
*/

(function () {
	'use strict';

	// rerun lazyload on screen size updates

	jQuery(window).on('resize', function () {
		dbs.lazyload();
	});

	// Load event function ... most custom stuff goes here. Safer for async.
	jQuery(window).on('load', function () {

		// Resize to parent
		jQuery('img.resize-to-parent, .resize-to-parent img').resizeToParent();

		// Search Form functionality
		jQuery('.search-form__button--open').on('click', function () {
			// The click functionality involves three different actions, depending on conditions the various clicks provide.

			// Clicking the search form button checks two classes to see if they are currently active
			var searchCloseLength = jQuery('.search_close').length;
			var openSearchField = jQuery('.search-form--active').length;

			// if .search-form--active is not present, the search field is opened, and the .search-form--active class is applied.
			// Note, this statement also prevents the .search_close span from triggering the search, unless the field is open
			function closeSearch() {
				jQuery('.search-form').removeClass('search-form--active');
				// JS solution
				setTimeout(function () {
					jQuery('.search-form__button--open').attr('aria-expanded', false);
					jQuery('body').removeClass('contains-open-search-field');
					jQuery('.search-form').css('visibility', 'hidden');
				}, 350);
			}

			if (openSearchField <= 0) {
				jQuery('.search-form').addClass('search-form--active');
				jQuery('body').addClass('contains-open-search-field');
				jQuery('.search-form__button--open').attr('aria-expanded', true);
				jQuery('.search-form').css('visibility', 'visible');

				// This function removes the classes related to an open search field, thus closing the search.
				jQuery('.search_close').on('click', function (e) {
					jQuery('.search-form__button--open').focus();
					e.stopPropagation();
					e.preventDefault();
					closeSearch();
				});

				jQuery('.search_close').on('keydown', function (e) {
					if (e.keyCode == 9 != e.shiftKey) {
						// tab key maps to keycode `9`
						e.preventDefault();
						jQuery('.search-input').focus();
					}
				});

				jQuery('.search-input').on('keydown', function (e) {
					if (e.keyCode == 9 && e.shiftKey) {
						// tab key maps to keycode `9`
						e.preventDefault();
						jQuery('.search_close').focus();
					}
				});

				var windowSize = jQuery(window).width();
				if (windowSize >= 992) {
					event.preventDefault();
					jQuery('.search-form__field').addClass('search-form__focus');
					jQuery('.search-input').focus();
				}
			}

			//Hide the search bar after click out of it
			jQuery('#content').on('click', function (e) {
				closeSearch();
			});

			jQuery(window).on('keyup', function (e) {
				if (e.keyCode == 27 && jQuery('.search-form').hasClass('search-form--active')) {
					// escape key maps to keycode `27`
					jQuery('.search-form__button--open').focus();
					closeSearch();
				}
			});
		});

		/**
   * Offsets page when scrolling to anchor link to account for sticky header height
   */

		var adjustAnchor = function adjustAnchor() {
			var $anchor = $(':target'),
			    fixedElementHeight = 200;
			if ($anchor.length > 0) {
				window.scrollTo(0, $anchor.offset().top - fixedElementHeight);
			}
		};
		$(window).on('hashchange load', function () {
			adjustAnchor();
		});

		// search child dom elements for a[href], and follow the fist one on click events 2015-11-03
		jQuery(".linkclicker").click(function (e) {
			var _this = jQuery(this);
			if (_this.find("a")) {
				e.preventDefault();
				if (_this.find("a:first").attr("target")) {
					// new tab
					window.open(_this.find("a:first").attr("href"));
				} else {
					// same tab
					window.location = _this.find("a:first").attr("href");
				}
			}
		});

		/**
  * Force external links to open in a new tab.
  * 2019-07-11 - TA
  */
		// From https://stackoverflow.com/questions/2910946/test-if-links-are-external-with-jquery-javascript
		function link_is_external(link_element) {
			return link_element.host !== window.location.host;
		}

		var anchorElements = document.getElementsByTagName('a');
		var _iteratorNormalCompletion = true;
		var _didIteratorError = false;
		var _iteratorError = undefined;

		try {
			for (var _iterator = anchorElements[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
				var anchorElement = _step.value;


				if (link_is_external(anchorElement)) {
					anchorElement.classList.add('external-link');
					anchorElement.setAttribute('target', '_blank');
					anchorElement.setAttribute('rel', 'noopener');

					// Add assistive text to alert of external links
					var assistiveText = '<span class="assistive">. External Link. Opens in new window.</span>';
					var assistiveTextContainer = document.createElement('span');
					assistiveTextContainer.innerHTML = assistiveText;
					anchorElement.appendChild(assistiveTextContainer.firstChild);
				}
			}

			// 2016-05-15, special declaration for pdf files
		} catch (err) {
			_didIteratorError = true;
			_iteratorError = err;
		} finally {
			try {
				if (!_iteratorNormalCompletion && _iterator.return) {
					_iterator.return();
				}
			} finally {
				if (_didIteratorError) {
					throw _iteratorError;
				}
			}
		}

		if (!jQuery('a').attr('target')) {
			jQuery('a[href$=".pdf"]').attr('target', '_blank');
		}
		// END FORCE EXTERNAL LINKS

		/**
   * 	The following removes gratuitous p tags inserted by the editor around img tags. 2018-03-28
  	 */
		jQuery(".layout p").each(function () {
			// For each paragraph of .layout class
			if (jQuery(this).find("img").length && // If there's an image
			!jQuery.trim(jQuery(this).text()).length) {
				// and there's no text, then ... get mean.
				jQuery(this).closest("p").find("*").first().addClass("unwrapped").unwrap(); // if the ancestor is a p tag, do what you have to do
			}
		}); // End p tag removal functionality

	}); // End of jQuery .load function

	// Include ready events here
	jQuery(function () {

		// ========================
		// Arrow-down button scroll
		// ========================
		jQuery('#down-button').click(function () {
			$('html, body').animate({
				scrollTop: $('main > div:nth-of-type(2)').offset().top - $('.site-header').height()
			}, 500);
		});
	});

	/**
  * Load CSS Files Dynamically
  *
  * Helpful for on demand loading of files not integral to the immediate
  * function of the site, saving initial load time.
  * For the inspiration of this function:
  * 	https://stackoverflow.com/questions/5680657/adding-css-file-with-jquery
 */

	jQuery.loadCSS = function (url) {
		// https://stackoverflow.com/questions/5680657/adding-css-file-with-jquery
		if (!$('link[href="' + url + '"]').length) if (document.createStyleSheet) {
			// ie fix
			document.createStyleSheet(url);
		} else {
			$('head').append('<link rel="stylesheet" type="text/css" href="' + url + '">');
		}
	};
})();